import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import {
  GlobalMessageService,
  GlobalMessageType, InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
  UserIdService
} from "@spartacus/core";
import { Subscription } from "rxjs";
import { AttentionCompany } from "./custom-care-company.model";

@Injectable({
  providedIn: 'root',
})
export class CustomAttentionCompanyService implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  userId: string;

  constructor(
    protected userIdService: UserIdService,
    protected occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    protected http: HttpClient
  ) {
    this.userIdService.takeUserId().subscribe(userID => this.userId = userID).unsubscribe();
  }

  subscribeRequest(data: AttentionCompany, form: UntypedFormGroup): void {
    const url = this.occEndpoints.buildUrl('attentionCompany', { urlParams: { userId: this.userId } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (this.userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    this.subscriptions.add(this.http.post<any>(url, { ...data }, { headers }).subscribe({
      next: data => {
        this.showGlobalMessage('forms.careCompany.success', GlobalMessageType.MSG_TYPE_CONFIRMATION);
        form.reset();
      }
    }));
  }

  protected showGlobalMessage(messageKey: string, messageType: GlobalMessageType): void {
    this.globalMessageService.add({ key: messageKey }, messageType);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
